import { TreeItem } from '@rbb/ng-web-template-lib';
import { AdminEmployeeListItem } from './admin-employee-list-item';

export class AdminOrgUnit {
  id: string | undefined;
  orgUnit: string | undefined;
  path: string | undefined;
  colloquialPath: string | undefined;
  chiefFirstName: string | undefined;
  chiefLastName: string | undefined;
  chiefUsername: string | undefined;
  chiefUidNumber: string | undefined;
  chiefEmailAddress: string | undefined;
  deputyChiefFirstName: string | undefined;
  deputyChiefLastName: string | undefined;
  deputyChiefUsername: string | undefined;
  deputyChiefUidNumber: string | undefined;
  deputyChiefEmailAddress: string | undefined;
  departmentFirstName: string | undefined;
  departmentLastName: string | undefined;
  departmentUsername: string | undefined;
  departmentUidNumber: string | undefined;
  departmentEmailAddress: string | undefined;
  deputyDepartmentFirstName: string | undefined;
  deputyDepartmentLastName: string | undefined;
  deputyDepartmentUsername: string | undefined;
  deputyDepartmentUidNumber: string | undefined;
  deputyDepartmentEmailAddress: string | undefined;
  department: string | undefined;
  mainDepartmentFirstName: string | undefined;
  mainDepartmentLastName: string | undefined;
  mainDepartmentUsername: string | undefined;
  mainDepartmentUidNumber: string | undefined;
  mainDepartmentEmailAddress: string | undefined;
  deputyMainDepartmentFirstName: string | undefined;
  deputyMainDepartmentLastName: string | undefined;
  deputyMainDepartmentUsername: string | undefined;
  deputyMainDepartmentUidNumber: string | undefined;
  deputyMainDepartmentEmailAddress: string | undefined;
  mainDepartment: string | undefined;
  directorFirstName: string | undefined;
  directorLastName: string | undefined;
  directorUsername: string | undefined;
  directorUidNumber: string | undefined;
  directorEmailAddress: string | undefined;
  deputyDirectorFirstName: string | undefined;
  deputyDirectorLastName: string | undefined;
  deputyDirectorUsername: string | undefined;
  deputyDirectorUidNumber: string | undefined;
  deputyDirectorEmailAddress: string | undefined;
  directorate: string | undefined;
  children: AdminOrgUnit[] | undefined;
  employees: AdminEmployeeListItem[] | undefined;

  static toTreeItem(adminOrgUnit: AdminOrgUnit): TreeItem {
    return {
      name: adminOrgUnit.orgUnit,
      children: (adminOrgUnit.employees?.map(e => AdminEmployeeListItem.toTreeItem(e)) ?? []).concat(adminOrgUnit.children?.map(ou => AdminOrgUnit.toTreeItem(ou)) ?? []),
      object: adminOrgUnit
    };
  }
}
